import { FunctionComponent } from 'react'
import CustomLayout from '@/components/RebrandedCustomLayout'

import { ReservationList } from '../../components/ReservationList'
import { ReservationListSkeleton } from '../../components/ReservationList/ReservationListSkeleton'
import { useReservationsConsultations } from '../../queries'

const ReservationConsultations: FunctionComponent = () => {
  const reservationConsultations = useReservationsConsultations()

  const isLoadingConsultations = reservationConsultations.isLoading
  return (
    <CustomLayout>
      <div>
        {isLoadingConsultations ? (
          <ReservationListSkeleton />
        ) : (
          <ReservationList />
        )}
      </div>
    </CustomLayout>
  )
}

export default ReservationConsultations
